import {
  STATUS_ERROR,
  STATUS_PENDING,
  STATUS_SUCCESS,
  StatusType,
} from '~/constants';

export function isLoading(asyncObject: { status: StatusType }) {
  return asyncObject.status === STATUS_PENDING;
}

export function isError(asyncObject: { status: StatusType }) {
  return asyncObject.status === STATUS_ERROR;
}

export function isSuccess(asyncObject: { status: StatusType }) {
  return asyncObject.status === STATUS_SUCCESS;
}

export const wait = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
